export const stepConfig = [
  {target: '.TextAreaContainer', key: 'textAreaContainer'},
  {target: '.CourseCardContainer', key: 'interactiveLessons'},
  {target: '.courseCardInfoRightBox', key: 'draftCourses'},
];
